// Is a paper still publishing? A paid paper whose newest edition is older than this is "not publishing right now":
// readers can't buy or subscribe to it from the home page or its paper page (old issues go through the archive).
// Owner rule, 2026-10-29. Books are bought once and never "stop".
export const LONG_GAP_DAYS = { newspapers: 14, magazines: 120 };
const TYPE_IDS = {
  "93fbee00-1da8-4af6-ade9-4f2909e94587": "newspapers",
  "aa73a161-6b76-4a15-a0a0-b1e51a3b7799": "magazines",
  "eb244fbc-ab2c-4a51-9b6f-034d987f352e": "books",
};
export const typeKeyOf = (pub) => String((pub && pub.type && pub.type.name) || TYPE_IDS[pub && pub.typeId] || "").toLowerCase();
export const daysSince = (date) => (date ? (Date.now() - new Date(date).getTime()) / 864e5 : Infinity);
export function notPublishing(pub, latestDate) {
  const key = typeKeyOf(pub);
  if (key === "books") return false;
  return daysSince(latestDate) > (LONG_GAP_DAYS[key] || 60);
}
